import { Button } from "primereact/button";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import "./resetPassword.css";
import { useToastContext } from "../Lib/Contexts/toastContext";
import { useResetPassword } from "../hooks/useGetDataQuery";

const ResetPassword = () => {


    const {
        mutate: resetPassword,
        isError: isErrorResetPassword,
        isSuccess: isSuccessResetPassword
    } = useResetPassword();


    const { t }: any = useOutletContext();
    const { showToast } = useToastContext();
    const [searchParams] = useSearchParams();
    const [decodedToken, setDecodedToken] = useState<string | null>(null);

    const [password, setPassword] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");

    const [passwordConfirmation, setPasswordConfirmation] = useState<string>("");
    const [passwordConfirmationError, setPasswordConfirmationError] = useState<string>("");

    const [successMode, setSuccessMode] = useState<boolean>(false);


    const navigate = useNavigate();

    useEffect(() => {
        const encodedToken = searchParams.get('token');

        if (encodedToken) {
            const decoded = decodeURIComponent(encodedToken);
            setDecodedToken(decoded);
        }
    }, [searchParams]);

    useEffect(() => {
        if (isSuccessResetPassword) {
            setSuccessMode(true);
        }
    }, [isSuccessResetPassword]);

    useEffect(() => {
        if (isErrorResetPassword) {
            showToast({ severity: 'error', summary: t('error'), detail: t('passwordResetFailed') });
        }
    }, [isErrorResetPassword]);

    const handleResetPassword = () => {
        let valid = true;
        if (!password) {
            setPasswordError('requiredField');
            valid = false;
        }

        if (!passwordConfirmation) {
            setPasswordConfirmationError('requiredField');
            valid = false;
        }

        if (!valid) return;

        if (password !== passwordConfirmation) {
            showToast({ severity: 'error', summary: t('error'), detail: t('passwordConfirmationError') });
            return;
        }

        resetPassword({ newPassword: password, token: decodedToken, confirmPassword: passwordConfirmation });
    }

    return (
        <>
            <img className="flex " src={successMode ? "/passwordResetSuccessIcon.png" : "/resetPasswordIcon.png"} alt="Forgot Password Image" />
            {!successMode && <p className="text-center text-4xl m-0 font-bold mt-4" style={{ color: "#2D3967" }}>{t('resetYourPassword')}</p>}
            {successMode && <p className="text-center text-4xl m-0 font-bold mt-4" style={{ color: "#2D3967" }}>{t('passwordResetSuccess')}</p>}
            {!successMode && <p className="text-center text-lg m-0 mt-2" style={{ color: "#727A99" }}>{t('resetYourPasswordDescription')}</p>}

            {!successMode && <div className="w-full">
                <FloatLabel className="w-full mt-4">
                    <Password invalid={passwordError != "" && !password} feedback={false} id="password" className='p-inputtext-lg w-full password' toggleMask variant='filled' value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleResetPassword();
                        }
                    }} />
                    <label htmlFor="password">{t('newPassword')}</label>
                </FloatLabel>
                {(passwordError != "" && !password) && <small className='text-red-500 text-xs'>{t(passwordError)}</small>}
            </div>}
            {!successMode && <div className="w-full">
                <FloatLabel className="w-full mt-4">
                    <Password invalid={passwordConfirmationError != "" && !passwordConfirmation} feedback={false} id="passwordConfirmation" className='p-inputtext-lg w-full password' toggleMask variant='filled' value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleResetPassword();
                        }
                    }} />
                    <label htmlFor="passwordConfirmation">{t('confirmNewPassword')}</label>
                </FloatLabel>
                {(passwordConfirmationError != "" && !passwordConfirmation) && <small className='text-red-500 text-xs'>{t(passwordConfirmationError)}</small>}
            </div>}

            <Button style={{ backgroundColor: "#6383F4", borderRadius: "10px", border: "none" }}
                className='w-full mt-4' size="large" label={successMode ? t('backToLogin') : t('resetPassword')} onClick={successMode ? () => navigate({ pathname: "/" }) : handleResetPassword} />
        </>
    );
};

export default ResetPassword;